import VerifyEmailDialog from "@/components/VerifyEmail.vue";
import { computed, ref } from "vue";
import { useDialog } from "primevue/usedialog";
import type { DynamicDialogInstance } from "primevue/dynamicdialogoptions";
import { until } from "@vueuse/core";

export const useVerifyEmailDialog = () => {
    const dialog = useDialog();
    const dialogRef = ref<DynamicDialogInstance & { visible?: boolean }>();
    const isVisible = computed(() => Boolean(dialogRef.value?.visible));
    const verificationSuccess = ref(false);

    /**
     * Opens dialog and returns when the dialog is closed with
     * the verificationSuccess value.
     */
    const open = async ({
        successCallback,
        failureCallback,
    }: {
        successCallback?: () => void;
        failureCallback?: () => void;
    } = {}) => {
        dialogRef.value = dialog.open(VerifyEmailDialog, {
            props: {
                header: "Verify Email",
                style: {
                    maxWidth: "600px",
                    width: "80%",
                },
                modal: true,
                maximizable: false,
                draggable: false,
            },
            data: {
                failureCallback: () => {
                    verificationSuccess.value = false;
                    failureCallback?.();
                },
                successCallback: () => {
                    verificationSuccess.value = true;
                    successCallback?.();
                },
            },
        });

        await until(isVisible).not.toBeTruthy();
        return verificationSuccess.value;
    };

    return { open, isVisible };
};
